import { SlidesConfig } from '@landr/maestro';

export const NB_SAMPLES_BY_CAROUSEL = 8;
export const NB_PACKS_BY_CAROUSEL = 12;
export const NB_ARTISTS_BY_CAROUSEL = 12;
export const NB_LABELS_BY_CAROUSEL = 12;

export const DEFAULT_NB_ENTITIES_BY_CAROUSEL = 12;

export const sampleCardsPerPage: SlidesConfig = {
    sm: 1,
    md: 2,
    lg: 3,
    default: 4,
};

export const detailedPackCardsPerPage: SlidesConfig = {
    sm: 1,
    md: 2,
    lg: 3,
    default: 4,
};

export const packCardsPerPage: SlidesConfig = {
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5,
    default: 6,
};

export const artistCardsPerPage: SlidesConfig = packCardsPerPage;
export const labelCardsPerPage: SlidesConfig = packCardsPerPage;
export const topPacksCardsPerPage: SlidesConfig = packCardsPerPage;
